import { useDispatch, useSelector } from 'react-redux';
import { Radio } from 'antd';

import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.scss';

import { selectPhotosType } from '../../store/slices/sensors';

const PhotosTypeSwitchExtended = ({ isGrayView }) => {
  const dispatch = useDispatch();
  const { photosType } = useSelector((state) => state.sensors);

  const onChangeView = (e) => {
    const value = e.target.value;
    dispatch(selectPhotosType(value));
  };
  
  return (
    <div className={`${styles.buttonsList} ${isGrayView ? styles.buttonsListGray : ''}`}>
      {/*<Button*/}
      {/*  className={`${styles.buttonsListItem} ${styles.buttonsListItemExtended} ${photosType === 'day' ? styles.buttonsListItemActive : ''}`}*/}
      {/*  type="default"*/}
      {/*  size={'small'}*/}
      {/*  icon={<DayIcon />}*/}
      {/*  onClick={() => {*/}
      {/*    dispatch(selectPhotosType('day'));*/}
      {/*  }}*/}
      {/*>RGB</Button>*/}
      {/*<Button*/}
      {/*  className={`${styles.buttonsListItem} ${styles.buttonsListItemExtended} ${photosType === 'night' ? styles.buttonsListItemActive : ''}`}*/}
      {/*  type="default"*/}
      {/*  size={'small'}*/}
      {/*  icon={<NightIcon />}*/}
      {/*  onClick={() => {*/}
      {/*    dispatch(selectPhotosType('night'));*/}
      {/*  }}*/}
      {/*>RGB</Button>*/}
      {/*<Button*/}
      {/*  className={`${styles.buttonsListItem} ${styles.buttonsListItemExtended} ${photosType === 'ndvi' ? styles.buttonsListItemActive : ''}`}*/}
      {/*  type="default"*/}
      {/*  size={'small'}*/}
      {/*  onClick={() => {*/}
      {/*    dispatch(selectPhotosType('ndvi'));*/}
      {/*  }}*/}
      {/*>NDVI</Button>*/}
      <Radio.Group
        className={'radio-group--bg radio-group--bg-white'}
        defaultValue={photosType === 'day' || photosType === 'ndvi' ? 'day' : 'night'}
        onChange={onChangeView}
      >
        <Radio.Button value="day">
          <CroplerIcon name="day" width={18} />
          <span className={styles.buttonsListItemText}>RGB</span>
        </Radio.Button>
        <Radio.Button value="night">
          <CroplerIcon name="night" width={16} />
          <span className={styles.buttonsListItemText}>RGB</span>
        </Radio.Button>
        <Radio.Button value="ndvi">
          <span className={styles.buttonsListItemText}>NDVI</span>
        </Radio.Button>
      </Radio.Group>
    </div>
  );
};

export default PhotosTypeSwitchExtended;